<template>
  <b-container class="container-layout" fluid>
    <Form :GetAccounts="GetAccounts" :premedios="premedios" />

    <b-row class="mt-n5">
      <Search :GetAccounts="GetAccounts" :accounts="accounts" />
    </b-row>
  </b-container>
</template>

<script>
import Form from "@/components/Admin/FormAccount";
import Search from "@/components/Admin/SearchAccount";

export default {
  name: "Cuentas",
  components: { Form, Search },
  data: () => ({
    accounts: [],
    premedios: []
  }),
  created() {
    this.$store.dispatch("setModulo", "GESTION DE CUENTAS");

    this.GetAccounts();
  },
  methods: {
    GetAccounts() {
      this.$store
        .dispatch("GetAccounts")
        .then(response => {
          this.accounts = response.data.accounts;
        
        })
        .catch(error => {
          console.log(error.message);
        });
    }
  },
  filters: {
    fixed(value) {
      return parseFloat(value).toFixed(0);
    }
  }
};
</script>
<style scoped>
</style>